import {
  ContentActionBar,
  ContentMain,
  ContentMui,
  ContentSideBarLeft,
  ContentSideBarRight,
  ContentTabs,
} from './Content';
import { Root } from './Root';
import { FiltersProvider, ResourceGuard, Wrapper } from './Wrapper';

export const PageMui = {
  Root,
  ResourceGuard,
  Content: ContentMui,
  ContentActionBar,
  ContentMain,
  ContentSideBarLeft,
  ContentSideBarRight,
  ContentTabs,
  Wrapper,
  FiltersProvider,
};
